// extracted by mini-css-extract-plugin
module.exports = {"Asset":"Asset_Asset__1dBcX"};